import "@/styles/globals.css";
import { ClerkProvider } from "@clerk/nextjs";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import { Inter } from "next/font/google";
import { persistor, store } from "@/redux/store";
import { Toaster } from "react-hot-toast";

const inter = Inter({ subsets: ["latin"] });

export default function App({ Component, pageProps }) {
  return (
    <ClerkProvider
      {...pageProps}
      localization={{
        signIn: {
          start: {
            title: "Sign in to Free Talent Assessment",
          },
        },
      }}
      appearance={{
        elements: {
          footer: "hidden",
        },
      }}
    >
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <main className={inter.className}>
            <Toaster />

            <Component {...pageProps} />
          </main>
        </PersistGate>
      </Provider>
    </ClerkProvider>
  );
}
